import React, { useState } from 'react'; //フック
import Functions from './Functions'; //Functionsコンポーネント
import Button from 'react-bootstrap/Button'; //Bootstrapコンポーネント

////////////////////////
// ▼▼▼ 関数コンポーネント
const CalcBtn = () => {
  const [flg, setFlg] = useState(true);
  const toggle = () => {
    const inputNum = document.getElementById('inputNum'); //経過日数入力欄
    const inputNumVal = inputNum.value; // テキスト入力欄の値
    const calendar = document.getElementById('calendar'); //カレンダー
    const radioWrap = document.getElementById('radioWrap'); //ラジオボタンを取得
    const nengou = document.getElementById('nangouInputField'); //年号を取得

     // ▼▼▼ 選択しているラジオボタンからのロジック
    for (let i = 0; i < radioWrap.radio.length; i++) {
      if (radioWrap.radio[i].checked) {
        switch (radioWrap.radio[i].value) {
          case "日前": // 日前を選択した場合
            var passedYears = "";
            var passedDays = inputNumVal * -1;
            break;
          case "年前": // 年前を選択した場合
            var passedYears = inputNumVal * -1;
            var passedDays = "";
            break;
          case "日後": // 日後を選択した場合
            var passedYears = "";
            var passedDays = inputNumVal * 1;
            break;
          case "年後": // 年後を選択した場合
            var passedYears = inputNumVal * 1;
            var passedDays = "";
            break;
        }
      }
    }
   
    // ▼▼▼ 入力された数値から年月日を算出する関数
    const setToDay = (days, years, cal) => {
      let getToday = new Date();
      getToday.setDate(getToday.getDate() + days); // 変更日を取得
      getToday.setFullYear(getToday.getFullYear() + years); // 変更年を取得
      let y = getToday.getFullYear(),
          m = getToday.getMonth() + 1,
          d = getToday.getDate();
      cal.value = `${Functions.zeroPadYear(y)}-${Functions.zeroPad(m)}-${Functions.zeroPad(d)}`; // 変更後の日付をカレンダーに表示
      document.getElementById('nangouInputField').innerText = Functions.getNengou(cal.value); //年号を表示
    }
    
    // ▼▼▼ カレンダー変更の関数
    const changeCalendar = () => {
      const changeCalVal = calendar.value; //変更したカレンダーの値を取得
      let getToday = new Date();
      let y = getToday.getFullYear(),
          m = getToday.getMonth() + 1,
          d = getToday.getDate();
      const todayCalDate = new Date(`${Functions.zeroPadYear(y)}-${Functions.zeroPad(m)}-${Functions.zeroPad(d)}`); // 今日の日付を'yyyy-mm-dd'形式で取得
      const changeCalDate = new Date(changeCalVal); // 入力した日付を'yyyy-mm-dd'形式で取得
      let differenceDays = ((todayCalDate - changeCalDate) / 86400000); // 86400000は、1日をミリ秒に換算
      if (differenceDays < 0) { // 変更日がマイナスの場合、後日の場合
        differenceDays = differenceDays * -1;
        document.getElementById('radio01').checked = false; // 日前のチェックを外す
        document.getElementById('radio03').checked = true; // 日後のチェックを入れる
      } else {
        document.getElementById('radio01').checked = true; // ラジオボタンを日数にする
      }
      document.getElementById('nangouInputField').innerText =Functions.getNengou(changeCalVal); //年号を表示
      document.getElementById('inputNum').value = differenceDays;
      document.getElementById('inputNum').disabled = true;
      document.getElementById('calendar').disabled = true;
    }
    
    setFlg(!flg);
    flg ?
      (v => { //数計算ボタン
        inputNum.disabled = true;
        calendar.disabled = true;
        if (inputNum.value != "") { // 入力欄に何か入力されたら
          setToDay(passedDays, passedYears, calendar);
        } else {
          changeCalendar();
        }
        
      })() :
      (v => { //クリアボタン
        inputNum.disabled = false;
        calendar.disabled = false;
        document.getElementById('radio01').checked = true; //日数をチェック
        inputNum.value = ""; //入力欄を空欄にする
        calendar.value = Functions.getToDay(); //カレンダーを今日に戻す
        nengou.innerText = Functions.getNengou(Functions.getToDay()); //年号を令和に戻す
      })();
  }

  return (
    <div className="card-body">
      <Button variant="primary" id={flg ? 'getNengouBtn' : 'clearBtn'} onClick={toggle}>{flg ? '日数計算' : 'クリア'}</Button>
    </div>
  );
}

export default CalcBtn;